import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './main.css';
import { App } from './App';
import { isPreview } from './realtime/connection';

/*
 * Предпросмотр в консоли помечает корень класса: по нему рисуется шахматка
 * прозрачности. В OBS признака нет, и страница остаётся прозрачной.
 */
if (isPreview()) {
  document.documentElement.classList.add('preview');
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден монтажный узел #root');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
